import "./Spinner.scss"

function Spinner() {
    return (
        <div className="loader-cont">
            <div className="loader"></div>
        </div>
    )
}

export default Spinner
